import { FormEvent, useState } from 'react';

import { toast, ToastContainer } from 'react-toastify';
import { useAdmin } from '../hooks/useAdmin';
import { BackgroundSVG } from '../components/BackgroundSVG';

import '../styles/pages-styles/adminlogin.scss';
import logoCarrano from '../assets/logo.svg';

export function AdminLogin() {
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');

    const { handleSignIn } = useAdmin();

    async function handleLogin(event: FormEvent) {
        event.preventDefault();

        try {
            await handleSignIn(email, password);

        } catch (error) {
            toast.error('Não foi possível autenticar seus dados, tente novamente em instantes!');
        }
    }

    return (
        <>
            <BackgroundSVG />
            <div className="container">
                <div className="logo-container">
                    <img src={logoCarrano} alt="CARRANO Logo" />
                </div>
                <h2 className="text-secondary text-regular text-center">ADMIN</h2>
                <div className="adminlogin-container">
                    <div className="adminlogin-header">LOGIN</div>
                    <div className="adminlogin-inputs">
                        <form onSubmit={handleLogin}>
                            <input
                                id="email"
                                type="email"
                                placeholder="Email"
                                name="email"
                                value={email}
                                onChange={event => setEmail(event.target.value)}
                            />
                            <input
                                id="password"
                                type="password"
                                placeholder="Senha"
                                name="password"
                                value={password}
                                onChange={event => setPassword(event.target.value)}
                            />
                            <button type="submit" id="submit">Entrar</button>
                        </form>
                    </div>
                </div>
                <ToastContainer />
            </div>
        </>
    )
}
